<template>
  <el-dialog :title="isEdit ? '编辑用户' : '新增用户'" :visible.sync="visible" width="500px">
    <el-form ref="form" :model="user" label-width="80px">
      <el-form-item label="账号" v-if="!isEdit">
        <el-input v-model="user.account" />
      </el-form-item>
      <el-form-item label="用户名" v-if="!isEdit">
        <el-input v-model="user.username" />
      </el-form-item>
      <el-form-item label="密码">
        <el-input v-model="user.password" type="password" />
      </el-form-item>
      <el-form-item label="支付密码">
        <el-input v-model="user.pay_password" type="password" />
      </el-form-item>
      <!-- <el-form-item label="角色">
        <el-select v-model="user.role">
          <el-option label="普通用户" :value="1" />
          <el-option label="管理员" :value="2" />
        </el-select>
      </el-form-item>
      <el-form-item label="状态">
        <el-select v-model="user.status">
          <el-option label="启用" :value="1" />
          <el-option label="停用" :value="0" />
        </el-select>
      </el-form-item> -->
    </el-form>
    <div slot="footer" class="dialog-footer">
      <el-button @click="closeDialog">取消</el-button>
      <el-button type="primary" @click="handleSubmit">确认</el-button>
    </div>
  </el-dialog>
</template>

<script>
import { createUser, updateUser } from '@/api/user'

export default {
  props: {
    visible: {
      type: Boolean,
      default: false
    },
    isEdit: {
      type: Boolean,
      default: false
    },
    user: {
      type: Object,
      default: () => ({})
    }
  },
  data() {
    return {
      dialogVisible: this.visible
    }
  },
  watch: {
    visible(newVal) {
      this.dialogVisible = newVal
    }
  },
  methods: {
    closeDialog() {
      this.dialogVisible = false
      this.$emit('update:visible', false)
    },
    handleSubmit() {
      if (this.isEdit) {
        updateUser(this.user.id, this.user).then(() => {
          this.$emit('refresh')
          this.closeDialog()
        })
      } else {
        createUser(this.user).then(() => {
          this.$emit('refresh')
          this.closeDialog()
        })
      }
    }
  }
}
</script>
